export const GET_USER_DATA = "GET_USER_DATA"
export const RESET_USER_DATA = "RESET_USER_DATA"

const saveUserDataSuccess = (data) => ({
  type: GET_USER_DATA,
  payload: data,
})

export const saveUserData = (data) => {
  return (dispatch) => {
    dispatch(saveUserDataSuccess(data))
  }
}

export const resetUserData = () => {
  return (dispatch) => {
    dispatch({ type: RESET_USER_DATA })
  }
}
